import { typography } from '@dentalux/ui-library-core'
import { createUseStyles } from 'react-jss'
import { forPhoneOnly } from 'src/config/mediaQueries'
import { Theme } from '@mui/material/styles'

export default createUseStyles((theme: Theme) => ({
  root: {
    display: 'flex',
  },
  container: {
    width: 450,
    maxWidth: 450,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  errorContainer: {
    marginTop: 12,
  },
  text: {
    ...typography['Lato H5'],
    [forPhoneOnly]: {
      ...typography['Lato Body 1'],
    },
  },

  form: {
    paddingTop: 32,
    width: '100%',
    [forPhoneOnly]: {
      paddingTop: 24,
    },
  },
  phoneInput: {
    width: '100%',
  },
  benefitsHeader: {
    width: '100%',
    marginTop: 56,
    marginBottom: 16,
    ...typography['Lato H5'],
    [forPhoneOnly]: {
      marginBottom: 24,
      marginTop: 48,
      ...typography['Lato Body 1'],
    },
  },
  benefits: {
    display: 'flex',
    flexDirection: 'column',
    gap: 16,
    width: '100%',
  },
  benefit: {
    display: 'flex',
    alignItems: 'center',
    gap: 16,
    ...typography['Lato Emphasized 1'],
    [forPhoneOnly]: {
      ...typography['Lato Emphasized 2'],
    },
  },
  benefitIcon: {
    borderRadius: '100%',
    background: theme.palette.primary.light,
    padding: 4,
    display: 'flex',
    [forPhoneOnly]: {
      padding: 3,
      '& svg': {
        width: 18,
        height: 18,
      },
    },
  },
}))
